import { RadialBarChart, RadialBar, Legend } from "recharts";
import { PieChart, Pie, Cell } from "recharts";

const ClosingProbabilityTile = ({ closingProbability }) => {
    const data = [
        { name: "Achieved", value: closingProbability },
        { name: "Remaining", value: 100 - closingProbability },
    ];

    const COLORS = ["#00C49F", "#D3D3D3"]; // Green and Gray

    return (
        <div className="closing-probability-chart-container">
            <PieChart width={120} height={120}>
                <Pie
                    data={data}
                    cx="50%"
                    cy="50%"
                    innerRadius={30}
                    outerRadius={50}
                    startAngle={90}
                    endAngle={450}
                    dataKey="value"
                    paddingAngle={5}
                >
                    {data.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={COLORS[index]} />
                    ))}
                </Pie>
            </PieChart>
            <div className="percentage-label">
                {closingProbability.toFixed(1)}%
            </div>
        </div>
    );
};

export default ClosingProbabilityTile;
